import React, { useEffect, useState } from "react";
import "./myaccount-mobile.scss";
import { FiBox } from "react-icons/fi";
import { GoBook } from "react-icons/go";
import { SlInfo } from "react-icons/sl";
import { IoMdBook } from "react-icons/io";
import { IoSaveOutline } from "react-icons/io5";
import { MdOutlineStorefront } from "react-icons/md";
import { GoCreditCard } from "react-icons/go";
import { FaRegEdit } from "react-icons/fa";
import { CiSaveDown1 } from "react-icons/ci";
import { CiSettings } from "react-icons/ci";
import { logout } from "../../actions/login/authActions";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import { Button, Box, Typography, Divider } from "@mui/material";
import Profile from "./components/profile/profile";
import { getProfile } from "../../actions/myaccount/profile/getProfileActions";
import { Menu as MenuIcon, Logout, DeleteForever } from "@mui/icons-material";
import { OrderFlow } from "../../App";
import { Modal } from "react-bootstrap";
import tableBookimg from "./sidebar/img/book.svg";

function MyaccountMobile({
  userData,
  logout,
  profile,
  getProfile,
  handleSideMenu,
}) {
  const [guest, setGuest] = useState([]);
  const guestAddress = localStorage.getItem("guestAddress") || "";
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const navigate = useNavigate();
  const profiledatas = profile?.data?.profile;
  const [width, setWidth] = useState(window.innerWidth);
  const breakpoint = 767;
  useEffect(() => {
    const handleResizeWindow = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, []);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    if (width > breakpoint) {
      setShow(true);
    } else {
      setShow(true);
    }
  };

  const { handleActivated } = OrderFlow();
  useEffect(() => {
    if (userData) {
      getProfile({
        customer_id: userData?.customerId,
        domain: window.location.hostname,
        body: "Your body",
      });
    }
  }, [userData, getProfile]);

  useEffect(() => {
    if (isLoggedIn !== "true") {
      const parsedUserData = guestAddress ? JSON.parse(guestAddress) : "";
      if (parsedUserData) {
        setGuest(parsedUserData);
      } else {
        navigate("/");
      }
    }
  }, [isLoggedIn, userData, navigate, guestAddress]);

  const handleLogout = () => {
    logout();
    navigate("/");
    handleSideMenu();
  };

  const handleNavigate = (path) => {
    if (width > breakpoint) {
      navigate(`/myaccount/${path}`);
    } else {
      navigate(`/${path}`);
    }
  };

  const [draw, setDraw] = useState(false);

  const toggleDrawer = () => {
    setDraw(true);
  };

  const [open, setOpen] = useState(false);

  const toggleDrawer2 = (state) => () => {
    setOpen(state);
  };

  return (
    <>
      <Drawer
        anchor={"bottom"}
        PaperProps={{
          sx: {
            borderRadius: "26px 26px 0 0",
            overflow: "hidden", // prevents content from bleeding over
          },
        }}
        open={draw}
        onClose={() => setDraw(false)}
      >
        <div className="">
          <Profile />
        </div>
      </Drawer>

      <Drawer
        anchor={"bottom"}
        PaperProps={{
          sx: {
            borderRadius: "26px 26px 0 0",
            overflow: "hidden", // prevents content from bleeding over
          },
        }}
        open={open}
        onClose={toggleDrawer2(false)}
      >
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          height="100%"
          p={3}
        >
          <Box>
            <Typography variant="h6" className="vbtn" gutterBottom>
              Setting
            </Typography>
            {/* <Divider sx={{ mb: 2 }} /> */}
          </Box>

          {/* Menu Actions */}
          <Box display="flex" flexDirection="column" className="pb-4" gap={2}>
            <Button
              variant="contained"
              color="inherit"
              className="vbtn"
              startIcon={<Logout />}
              onClick={() => handleLogout()}
              fullWidth
            >
              Logout
            </Button>

            <Button
              variant="outlined"
              color="error"
              startIcon={<DeleteForever />}
              className="vbtn"
              onClick={handleActivated}
              fullWidth
            >
              Account Deletion
            </Button>
          </Box>
        </Box>
      </Drawer>

      {width > breakpoint ? (
        <Modal
          show={show}
          onHide={handleClose}
          centered
          className={`preorder-popup `}
        >
          <Modal.Body>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
              height="100%"
              p={3}
            >
              <h4 className="form-textsidebarv3 vbtn">Log out From ?</h4>
              <p className="modal-buttoncurr"></p>
              <Box
                display="flex"
                flexDirection="column"
                className="pb-4"
                gap={2}
              >
                <Button
                  variant="contained"
                  color="inherit"
                  className="vbtn"
                  onClick={() => handleLogout()}
                  fullWidth
                >
                  Current Device
                </Button>

                <Button
                  variant="outlined"
                  color="error"
                  className="vbtn"
                  onClick={handleClose}
                  fullWidth
                >
                  cancel
                </Button>
              </Box>
            </Box>
          </Modal.Body>
        </Modal>
      ) : (
        <Drawer
          anchor={"bottom"}
          PaperProps={{
            sx: {
              borderRadius: "26px 26px 0 0",
              overflow: "hidden", // prevents content from bleeding over
            },
          }}
          open={show}
          onClose={handleClose}
        >
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            height="100%"
            p={3}
          >
            <h4 className="form-textsidebarv3 vbtn">Log out From ?</h4>
            <p className="modal-buttoncurr"></p>
            <Box display="flex" flexDirection="column" className="pb-4" gap={2}>
              <Button
                variant="contained"
                color="inherit"
                className="vbtn"
                onClick={() => handleLogout()}
                fullWidth
              >
                Current Device
              </Button>

              <Button
                variant="outlined"
                color="error"
                className="vbtn"
                onClick={handleClose}
                fullWidth
              >
                cancel
              </Button>
            </Box>
          </Box>
        </Drawer>
      )}

      <div className="my-account-mob pb-5 vh-100">
        <div className="container pt-3 pt-sm-0 pb-5">
          <div
            className="acc-card mb-3 mt-sm-0 mb-sm-0"
            onClick={() =>
              width > breakpoint ? navigate("/myaccount") : toggleDrawer()
            }
          >
            <div className="d-flex link align-items-center justify-content-between">
              <div className="">
                {userData && isLoggedIn === "true" ? (
                  <h3 className="text-capitalize">
                    {userData.fname && userData.fname}
                  </h3>
                ) : (
                  <h3 className="text-capitalize">
                    {guest?.firstName} {guest?.lastName}
                  </h3>
                )}
                <p className="mb-0">{profiledatas?.phone}</p>
                <p className="mb-0">{profiledatas?.email}</p>
              </div>
            </div>
          </div>

          {/* <Divider sx={{ borderColor: "gainsboro" }} /> */}
          <div className="border my-1 w-100"></div>

          <div className="acc-card mt-3 mt-sm-0 mb-sm-0">
            <div className="">
              <h3>Food Order</h3>
              <div
                onClick={() => handleNavigate("yourorder")}
                // onClick={() => navigate("/yourorder")}
                className="d-flex mt-4 link align-items-center pb-3 border-bottom justify-content-between"
              >
                <div className="d-flex align-items-center  gap-2">
                  <FiBox size={25} />
                  <h4 className="mb-0">Your Orders</h4>
                </div>
              </div>
              <div
                onClick={() => handleNavigate("addressbook")}
                // onClick={() => navigate("/addressbook")}
                className="d-flex mt-3 link align-items-center pb-3 border-bottom justify-content-between"
              >
                <div className="d-flex align-items-center  gap-2">
                  <GoBook size={25} />
                  <h4 className="mb-0">Address Book</h4>
                </div>
              </div>
              <div
                onClick={() => handleNavigate("help")}
                // onClick={() => navigate("/help")}
                className="d-flex mt-3 link align-items-center  justify-content-between"
              >
                <div className="d-flex align-items-center  gap-2">
                  <SlInfo size={25} />
                  <h4 className="mb-0">Online Ordering Help</h4>
                </div>
              </div>
            </div>
          </div>

          {/* <Divider sx={{ borderColor: "#dee2e6" }} /> */}
          <div className="border my-1 w-100"></div>

          <div className="acc-card mt-3 mt-sm-0 mb-sm-0">
            <div className="">
              <h3>Your Bookings</h3>
              <div
                onClick={() => handleNavigate("tablebooking")}
                // onClick={() => navigate("/tablebooking")}
                className="d-flex mt-4 link align-items-center justify-content-between"
              >
                <div className="d-flex align-items-center  gap-2">
                  {/* <IoMdBook size={25} /> */}
                  <img src={tableBookimg} className="" alt="table-book" />
                  <h4 className="mb-0">Your Table Bookings</h4>
                </div>
              </div>
            </div>
          </div>

          {/* <Divider sx={{ borderColor: "#dee2e6" }} /> */}
          <div className="border my-1 w-100"></div>

          <div className="acc-card mt-3 mt-sm-0 mb-sm-0">
            <div className="">
              <h3>Payments</h3>
              <div
                onClick={() => handleNavigate("savedcards")}
                // onClick={() => navigate("/savedcards")}
                className="d-flex mt-4 link align-items-center justify-content-between"
              >
                <div className="d-flex align-items-center  gap-2">
                  <GoCreditCard size={25} />
                  <h4 className="mb-0">Saved Cards</h4>
                </div>
              </div>
            </div>
          </div>

          {/* <Divider sx={{ borderColor: "#dee2e6" }} /> */}
          <div className="border my-1 w-100"></div>

          <div className="acc-card mt-3 mt-sm-0 mb-sm-0">
            <div className="">
              <h3>More</h3>
              <div
                onClick={() => handleNavigate("/feedbackmyaccount")}
                // onClick={() => navigate("/feedbackmyaccount")}
                className="d-none mt-4 link align-items-center pb-3 border-bottom justify-content-between"
              >
                <div className="d-flex align-items-center  gap-2">
                  <FaRegEdit size={25} />
                  <h4 className="mb-0">Send Feedback</h4>
                </div>
              </div>

              {/* <div
                onClick={toggleDrawer2(true)}
                className="d-flex mt-3 link align-items-center pb-3 border-bottom justify-content-between"
              >
                <div className="d-flex align-items-center  gap-2">
                  <CiSettings size={25} />
                  <h4 className="mb-0">Settings</h4>
                </div>
              </div> */}

              <div
                // onClick={toggleDrawer2(true)}
                className="d-flex mt-3 link align-items-center pb-3 border-bottom justify-content-between"
              >
                <div
                  className="d-flex align-items-center gap-2"
                  onClick={() =>
                    window.open(
                      "https://fusionmybusiness.com/get-started",
                      "_blank"
                    )
                  }
                >
                  <MdOutlineStorefront size={25} />
                  <h4 className="mb-0">Add your restaurant</h4>
                </div>
              </div>
              {isLoggedIn === "true" ? (
                <div
                  onClick={() => handleShow()}
                  role="button"
                  className="d-flex mt-3 link align-items-center justify-content-between"
                >
                  <div className="d-flex align-items-center  gap-2">
                    <CiSaveDown1 className="text-danger" size={25} />
                    <h4 className="mb-0 text-danger">Logout</h4>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  userData: state.userdata.userData,
  profile: state.profile.profile,
});

const mapDispatchToProps = {
  logout,
  getProfile,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyaccountMobile);
